module.exports = window["wp"]["blockLibrary"];